import { Button, Modal, Typography } from "@trustpilot/constellation-components";
import { check_16 as check16 } from "@trustpilot/icons";
import { useTranslations, interpolate, HtmlText } from "ilenia";
import { useEffect, MouseEvent } from "react";
import { useHistory } from "react-router-dom";

import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import {
  MarginButton,
  MarginIcon,
  MarginTypography,
  MarginUnorderedList,
  MarginUnorderedListItem,
  StyledModal,
  StyledModalBody,
  StyledModalCustomerFooter,
  StyledModalTextContainer,
} from "../../styled";
import * as Types from "../../types/types";
import freeTrialModalImage from "./trial-modal-image.svg";

export const FreeTrialModal: React.FC<Types.FreeTrialModal> = ({ open, onClose, duration }) => {
  const history = useHistory();
  const analytics = useAnalytics();
  const [translations] = useTranslations();
  const localisationRoot = "Sidebar.freeTrialModal";
  const upgradeRoute = "/upgrade?upgradeSource=FreeTrialModal";
  const checkoutRoute = "/subscription?businessModules=plus";

  useEffect(() => {
    analytics.track(trackingConst.events.elementViewed, {
      context: trackingConst.contexts.freeTrialModal,
    });
  }, []);

  const handleClick = (e: MouseEvent, route: string) => {
    e.preventDefault();
    analytics.track(trackingConst.events.linkClicked, {
      context: trackingConst.contexts.freeTrialModal,
      name:
        route === upgradeRoute
          ? trackingConst.names.freeTrialUpradeLinkClick
          : trackingConst.names.freeTrialCheckoutLinkClick,
    });
    onClose(true);
    history.push(route);
  };
  return (
    <StyledModal onClose={onClose} open={open}>
      <Modal.Header>{interpolate(`${translations[`${localisationRoot}.title`]}`, { duration })}</Modal.Header>
      <StyledModalBody>
        <img src={freeTrialModalImage} alt="" role="presentation" />
        <StyledModalTextContainer>
          <Typography variant="display-m" as="h3">
            {translations[`${localisationRoot}.heading`]}
          </Typography>
          <MarginTypography variant="body-m">{translations[`${localisationRoot}.body`]}</MarginTypography>
          <MarginUnorderedList aria-label={translations[`${localisationRoot}.listAriaLabel`]}>
            {[1, 2, 3, 4].map((i) => (
              <MarginUnorderedListItem>
                <MarginIcon content={check16} />
                <Typography variant="body-m">
                  <HtmlText
                    id={`${localisationRoot}.bulletPoint${i}`}
                    interpolations={{
                      "BOLD-START": '<b key="bold">',
                      "BOLD-END": "</b>",
                    }}
                  />
                </Typography>
              </MarginUnorderedListItem>
            ))}
          </MarginUnorderedList>
        </StyledModalTextContainer>
      </StyledModalBody>
      <StyledModalCustomerFooter>
        <Button
          appearance="secondary"
          as="a"
          href={upgradeRoute}
          onClick={(e: MouseEvent) => handleClick(e, upgradeRoute)}
        >
          {translations[`${localisationRoot}.upgradeLink`]}
        </Button>
        <MarginButton
          appearance="primary"
          as="a"
          href={checkoutRoute}
          onClick={(e: MouseEvent) => handleClick(e, checkoutRoute)}
        >
          {translations[`${localisationRoot}.checkoutLink`]}
        </MarginButton>
      </StyledModalCustomerFooter>
    </StyledModal>
  );
};
